import statesOptionData from '@selector-options/states'
import { LeadgenPopupType } from '@components/LeadgenPopupFlow'

export const getInputsFromData = (variant: LeadgenPopupType): Record<string, QuestionDataInput> => {
  switch (variant) {
    case 'LIFE_INSURANCE':
      return {
        address_state: {
          key: 'address_state',
          title: 'State',
          type: 'selector',
          placeholder: 'Select',
          optionSet: 'state',
          autocomplete: 'shipping region',
          options: statesOptionData
        }
      }
    default:
      return {
        address_zip: {
          title: 'Please enter your zip code',
          key: 'address_zip',
          type: 'tel',
          placeholder: 'Zip',
          formatter: 'zipcode',
          validator: 'zipcode'
        }
      }
  }
}
